var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyImgPlaylist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 350,
    height: 202,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M350 0H0v202h350V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M175 181c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80Z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M201.683 37.257h-88.147c-2.83 0-5.124 1.915-5.124 4.278v89.839c0 2.363 2.294 4.278 5.124 4.278h88.147c2.83 0 5.124-1.915 5.124-4.278v-89.84c0-2.362-2.294-4.277-5.124-4.277Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M150.246 53.513h-26a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    d: "M198.246 66.513h-74a3 3 0 1 0 0 6h74a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M150.246 80.513h-26a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    d: "M168.246 93.513h-44a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M150.246 107.513h-26a3 3 0 0 0 0 6h26a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    d: "M198.246 120.513h-74a3 3 0 0 0 0 6h74a3 3 0 1 0 0-6Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M209.95 46.669h-88.146c-2.83 0-5.125 1.915-5.125 4.278v89.839c0 2.363 2.295 4.278 5.125 4.278h88.146c2.83 0 5.125-1.915 5.125-4.278v-89.84c0-2.362-2.295-4.277-5.125-4.277Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M169.636 65.492h-26a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    d: "M217.636 78.492h-74a3 3 0 1 0 0 6h74a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M169.636 92.492h-26a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    d: "M187.636 105.492h-44a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M169.636 119.492h-26a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    d: "M217.636 132.492h-74a3 3 0 1 0 0 6h74a3 3 0 1 0 0-6Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M224.198 164.088C210.628 174.685 193.551 181 175 181c-18.552 0-35.628-6.314-49.198-16.911V64.19c0-3.061 2.294-5.543 5.125-5.543h88.146c2.83 0 5.125 2.482 5.125 5.543v99.898Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M167.636 74.904h-26a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    d: "M215.636 87.904h-74a3 3 0 1 0 0 6h74a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M167.636 101.904h-26a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    d: "M185.636 114.904h-44a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M167.636 128.904h-26a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    d: "M185.636 141.904h-44a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4DAFF",
    d: "M167.636 155.904h-26a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    fillRule: "evenodd",
    d: "M144.315 174.904a79.434 79.434 0 0 1-5.655-2.615 3 3 0 0 1 2.976-3.385h74c.445 0 .866.097 1.246.27a79.802 79.802 0 0 1-11.197 5.73h-61.37Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 100.395,
    height: 100.395,
    x: 106.412,
    y: 35.257,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_2202_76127"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 105.957,
    height: 100.396,
    x: 114.679,
    y: 44.669,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_2202_76127"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 100.396,
    height: 124.353,
    x: 123.802,
    y: 56.647,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_2202_76127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 175,
    x2: 175,
    y1: 21,
    y2: 181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h350v202H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImgPlaylist);
export default __webpack_public_path__ + "static/media/empty-img-playlist.bbc2eac8923d88398da1f059016ad6c0.svg";
export { ForwardRef as ReactComponent };